import { base_url } from './urls';
import axios from 'axios';
import Cookies from 'js-cookie';
// import { useAuth } from '../context/AuthProvider';

// ===============================================
// AXIOS PARA LOS ENDPOINTS
// ===============================================

const myApi = axios.create({

    baseURL: base_url

});

// const { logOut } = useAuth();

// ===============================================
// AXIOS PARA LOS ENDPOINTS
// ===============================================

myApi.interceptors.request.use((config) => {

    const token = Cookies.get('ebt_token');

    if(token){

        config.headers['access-token'] = token;

    }

    return config;

}, (error) => {

    return Promise.reject(error);

});

myApi.interceptors.response.use((response) => {

    return response;

}, (error) => {

    if(error.response.status === 500){

        //logOut();
        console.log(error)

    }

    return Promise.reject(error);

});

// ===============================================
// AXIOS PARA MANDAR FOTOS Y ARCHIVOS
// ===============================================

const myApiFiles = async (url, data, method = "POST") => {

    try {

        const config = {

            headers: {
                'Content-Type': 'multipart/form-data'

            }
            
        }

        const response = await myApi[method.toLowerCase()](url, data, config);

        return response.data;

    } catch( error ){

        throw error;

    }

}

// ===============================================
// AXIOS PARA DESCARGAR ARCHIVOS
// ===============================================

const myApiDownload = axios.create({

    baseURL: base_url,
    responseType: 'blob'

});

myApiDownload.interceptors.request.use((config) => {

    const token = Cookies.get('pk9_token');

    if(token){

        config.headers['Authorization'] = `Bearer ${token}`;

    }

    return config;

}, (error) => {

    return Promise.reject(error);

});

myApiDownload.interceptors.response.use((response) => {

    return response;

}, (error) => {

    if(error.response.status === 500){

        //logOut();

    }

    return Promise.reject(error);

});

export { myApi, myApiFiles, myApiDownload };